import { normalizeFlatpickrLocale } from '@resources/js/components/form/helpers/normalizeFlatpickrLocale'

export const loadFlatpickrLocale = async localeLang => {
	const normalizedLocale = normalizeLocale(localeLang)
	const resolvedLocale = normalizeFlatpickrLocale(normalizedLocale)
	if (resolvedLocale === 'en') return

	try {
		return await getLocale(resolvedLocale)
	} catch (err) {
		console.error(err)
	}
}

const getLocale = async localeLang => {
	const localeModule = await import(`flatpickr/dist/l10n/${localeLang}.js`)
	return localeModule.default[localeLang]
}

const normalizeLocale = locale => locale.trim().toLowerCase()
